import { render } from "./Arrematacoes.vue?vue&type=template&id=12c67eaf"
import script from "./Arrematacoes.vue?vue&type=script&lang=js"
export * from "./Arrematacoes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__